<template>
  <div class="rank-page-box">
    <!-- 表格数据 -->
    <el-table :data="tableDate"  style="width: 100%" border  v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
      <el-table-column prop="" label="榜单ID" align="center"></el-table-column>
      <el-table-column prop="" label="排序" align="center"></el-table-column>
      <el-table-column prop="" label="榜单名称" align="center"></el-table-column>
      <el-table-column prop="" label="榜单底色" align="center">
        <template slot-scope="scope">
          <img-load :width="'60px'" :height="'80px'" :src="imgUrl + scope.row.cover"></img-load>
        </template>
      </el-table-column>
      <el-table-column prop="" label="类别" align="center"></el-table-column>
      <el-table-column prop="" label="关联" align="center"></el-table-column>
      <el-table-column prop="" label="开始时间" align="center">
        <template slot-scope="scope">
          {{scope.row.startTime | changeDate}}
        </template>
      </el-table-column>
      <el-table-column prop="" label="结束时间" align="center">
        <template slot-scope="scope">
          {{scope.row.startTime | changeDate}}
        </template>
      </el-table-column>
      <el-table-column prop="" label="状态" align="center">
        <el-switch v-model="params.turnOn"></el-switch>
      </el-table-column>
       <el-table-column label="操作" align="center" fixed="right" width="130">
        <template slot-scope="scope">
          <el-button type="success" size="mini"  @click="editRank('edit',scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination :page-sizes="[10, 15, 20, 25]" :current-page="params.pageNumber" :page-size="params.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" background v-if="total > 10" @size-change="changeSize" @current-change="changeCurrent"></el-pagination>
    <!-- 编辑弹窗 -->
    <edit-rank ref="editRank" @handlerRankList="handlerRankList"></edit-rank>
  </div>
</template>
<script>
import baseConfig from '@/utils/serverUrlConfig'
import EditRank from './components/editRank'
import API from '@/api'
export default {
  data() {
    return {
      loading: false,
      tableDate: [1],
      total: 0,
      imgUrl: baseConfig.imgUrl,
      params: {
        pageNumber: 1,
        pageSize: 10,
        turnOn :false
      }
    }
  },
  created() {
    // this.getRankList()
  },
  components: {
    EditRank
  },
  methods: {
    // 请求排行列表数据
    getRankList() {
      this.loading = true
      API.getRankList(this.params).then(res => {
        if (res.code === 200 && res.data) {
          this.tableData = res.data
          this.total = res.data.total
        } else {
          this.tableData = []
          this.total = 0
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
     // 监听编辑成功过后重新拉去数据
    handlerRankList() {
      this.param.pageNumber = 1
      this.param.pageSize = 10
      this.getRankList()
    },
    // 编辑排行弹窗
     editRank(type,row) {
      this.$refs.editRank.open(type,row)
    },
    // 分页条数改变回掉
    changeSize(size) {
      this.params.pageSize = size
      this.getRankList()
    },
    // 分页页码改变回掉
    changeCurrent(number) {
      this.params.pageNumber = number
      this.getRankList()
    },
  }
}
</script>
